import React from 'react';
export function CTASection() {
  return <section className="bg-white py-[60px] md:py-[100px] px-6" data-id="element-28">
      <div className="max-w-[700px] mx-auto text-center" data-id="element-29">
        <h2 className="md:text-section-tablet lg:text-section-desktop text-charcoal mb-6 font-[500]" data-id="element-30">
          Experience Glenlofty
        </h2>

        <p className="text-[20px] text-charcoal/90 mb-10 leading-relaxed" data-id="element-31">
          We love to hear from fellow wine lovers. Whether you have a question,
          want to plan a visit, or simply want to say hello, please get in
          touch.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-6" data-id="element-32">
          <button className="border border-charcoal bg-charcoal text-white px-16 py-4 uppercase tracking-[0.2em] font-medium hover:bg-white hover:text-charcoal hover:-translate-y-[2px] hover:shadow-[0_4px_12px_rgba(0,0,0,0.08)] transition-all duration-300 ease-out" data-id="element-33">
            Shop Wines
          </button>

          <button className="border border-charcoal bg-white text-charcoal px-16 py-4 uppercase tracking-[0.2em] font-medium hover:bg-charcoal hover:text-white hover:-translate-y-[2px] hover:shadow-[0_4px_12px_rgba(0,0,0,0.08)] transition-all duration-300 ease-out" data-id="element-34">
            Contact Us
          </button>
        </div>
      </div>
    </section>;
}